import React from "react";

import { ListGroup, ListGroupItem } from "components/ListGroup";
import RoleCard from "./RoleCard";
import RolesHeadings from "./RolesHeadings";

interface Props {
	roles: { [key: string]: string };
}

const RolesTable = ({ roles }: Props) => {
	return (
		<div className="mb-20">
			<RolesHeadings />
			<ListGroup className="list-group-links">
				{Object.keys(roles).map(role => (
					<ListGroupItem key={role}>
						<div className="list-group-card-link variables__card">
							<RoleCard role={role} description={roles[role]} />
						</div>
					</ListGroupItem>
				))}
			</ListGroup>
		</div>
	);
};

export default RolesTable;
